import { BetType, BettingCartType, OddsType, selectCurrentOddsType, useAppSelector } from '@supersports/services';
import { useMemo } from 'react';

export function calculateOddByOddsType(oddNumber: number, oddsType: OddsType, betType: BetType) {
  if (betType !== BetType.HDP && betType !== BetType.OU && betType !== BetType.OE) {
    return oddNumber;
  }

  if (oddsType === OddsType.MY) {
    return oddNumber;
  }

  if (oddsType === OddsType.HK || oddsType === OddsType.DE) {
    const newOddNumber = Math.round((oddNumber > 0 ? oddNumber : Math.abs(1.0 / oddNumber)) * 100.0) / 100;

    if (oddsType === OddsType.DE) {
      return newOddNumber + 1;
    }

    return newOddNumber;
  }

  if (oddsType === OddsType.US || oddsType === OddsType.ID) {
    let odds = oddNumber;
    if (odds < 0) {
      if (odds < -0.79) {
        odds = Math.floor(Math.abs(100.0 / odds)) / 100.0;
      } else {
        odds = Math.ceil(Math.abs(100.0 / odds)) / 100.0;
      }
    } else if (odds > 0 && odds < 10.0) {
      if (odds > 0.79) {
        odds = -Math.floor(Math.abs(100.0 / odds)) / 100.0;
      } else {
        odds = -Math.ceil(Math.abs(100.0 / odds)) / 100.0;
      }
    }

    if (oddsType === OddsType.US) {
      odds *= 100;
    }

    return odds;
  }
  return oddNumber;
}

/**
 * Calculates and returns the odds based on the given odd number and the current odds type.
 *
 * @param {number} oddNumber - The odd number to calculate the odds for.
 *
 * @return {Array<number, string>} An array containing the calculated odds and the formatted odds as a string.
 */
export function useOddsTypeCalculator(
  oddNumber: number,
  betType: BetType = BetType.HDP,
  bettingCartType: BettingCartType
) {
  const oddsType = useAppSelector(selectCurrentOddsType);
  const result = useMemo<number>(() => {
    if (bettingCartType === BettingCartType.Parlay) {
      return oddNumber;
    }

    return calculateOddByOddsType(oddNumber, oddsType, betType);
  }, [oddsType, oddNumber]);

  return [result, oddsType === OddsType.US ? result.toFixed(0) : result.toFixed(2)];
}
